import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { host } from '../../function/api'
import $ from 'jquery'
import * as moment from 'jalali-moment';
import * as Icon from 'react-feather';
import Loading from '../../Loading'

function Plans() {
    const [menuData, setMenuData] = useState()
    const [loading, setLoading] = useState('0')
    const dispatch = useDispatch()
    const token = localStorage.getItem('token')
    const menus = useSelector(state => state.navbar.menus)
    const message = useSelector(state => state.navbar.message)
    const { username, mobile, email } = JSON.parse(localStorage.getItem('user'))
    const [planDetails, setPlanDetails] = useState({})
    


    const rahpardaznet_payment = async (amount, countRequest, countMonths) => {
        try {
            const data = {
                'amount': amount,
                'count_request': countRequest,
                'count_months': countMonths
            }
            const response = await axios({
                method: 'POST',
                url: `${host}agent/plan/paymnet`,
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            if (response.data.status == true && response.data.payment_url != null) {
                toast.success('شما در حال انتقال هستید ...', {
                    position: "top-center",
                    autoClose: 1200,
                })
                window.location.href = response.data.payment_url;

            }
        } catch (error) {
            console.log(error);
            toast.error(error.response.data.message, {
                position: "top-center",
                autoClose: 5000,
            })
        }
    }


    const rahpardaznet_plans = async () => {
        try {
            setPlanDetails({});
            const response = await axios({
                method: 'GET',
                url: `${host}agent/plan/status`,
                headers: {
                    'Accept': 'application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }

            })

        setLoading('0');
            if (response.data.status === true) {
                setPlanDetails(response.data.data);
            }
        } catch (error) {
            setLoading('0');
            console.log(error);
            toast.error(error.response.data.message, {
                position: "top-center",
                autoClose: 5000,
            })
        }
        
    }
    useEffect(() => {
        setPlanDetails({});
        setLoading('1');
        rahpardaznet_plans();

    }, [])
    return (
        <>
        {loading == '1' ? <Loading /> : null}
            {
                (typeof planDetails === 'object' && Object.keys(planDetails).length != 0) ? (

                    <>
                        <div className='row rahpardaznet-plan-details'>
                            <div className='col-12 col-md-4'>
                                <div className='rahpardaznet-payment-item'>
                                    <label>تاریخ خرید اشتراک: </label>
                                    <span>{moment(planDetails.start_date).locale('fa').format('YYYY/MM/DD HH:mm:ss')}</span>
                                </div>
                                <div className='rahpardaznet-payment-item'>
                                    <label>تاریخ پایان اشتراک: </label>
                                    <span>{moment(planDetails.end_date).locale('fa').format('YYYY/MM/DD HH:mm:ss')}</span>
                                </div>
                            </div>
                            <div className='col-12 col-md-4 border-right border-left'>
                                <div className='rahpardaznet-payment-item'>
                                    <label>تعداد روز باقی مانده: </label>
                                    <span>{planDetails.count_date}  روز</span>
                                </div>
                                <div className='rahpardaznet-payment-item'>
                                    <label>تعداد درخواست باقی مانده: </label>
                                    <span>{planDetails.count_request}</span>
                                </div>
                            </div>
                            <div className='col-12 col-md-4'>
                                <div className='rahpardaznet-payment-item'>
                                    <label>شماره تراکنش: </label>
                                    <span>{planDetails.transactionId}</span>
                                </div>
                                <div className='rahpardaznet-payment-item'>
                                    <label>نوع پکیج: </label>
                                    <span>{planDetails.count_months}</span>
                                </div>
                            </div>
                        </div>
                    </>

                ) : null
            }


{
                (Object.keys(planDetails).length == 0 || planDetails.count_request == 0 || planDetails.count_date == 0) ? (

                    <>
                     <div id="generic_price_table">
                        <div className="row">
                            <div className="col-md-4">

                                <div className="generic_content clearfix">

                                    <div className="generic_head_price clearfix">

                                        <div className="generic_head_content clearfix">

                                            <div className="head_bg"></div>
                                            <div className="head">
                                                <span>یک ماهه</span>
                                            </div>

                                        </div>
                                        <div className="generic_price_tag clearfix">
                                            <span className="price">
                                                <span className="currency">10,000,000</span>
                                                <span className="sign">ریال</span>
                                            </span>
                                        </div>

                                    </div>
                                    <div className="generic_feature_list">
                                        <ul>
                                            <li>ثبت <span>8</span> درخواست سند</li>
                                        </ul>
                                    </div>
                                    <div className="generic_price_btn clearfix">
                                        <button type="button" onClick={(e) => rahpardaznet_payment('10000000', '8', '1')}>خرید اشتراک</button>
                                    </div>

                                </div>

                            </div>

                            <div className="col-md-4">

                                <div className="generic_content active clearfix">

                                    <div className="generic_head_price clearfix">

                                        <div className="generic_head_content clearfix">

                                            <div className="head_bg"></div>
                                            <div className="head">
                                                <span>یک ساله</span>
                                            </div>

                                        </div>
                                        <div className="generic_price_tag clearfix">
                                            <span className="price">
                                                <span className="currency">40,000,000</span>
                                                <span className="sign">ریال</span>
                                            </span>
                                        </div>

                                    </div>
                                    <div className="generic_feature_list">
                                        <ul>
                                            <li>بدون محدودیت درخواست</li>
                                        </ul>
                                    </div>

                                    <div className="generic_price_btn clearfix">
                                        <button type="button" onClick={(e) => rahpardaznet_payment('40000000', '0', '12')}>خرید اشتراک</button>
                                    </div>

                                </div>

                            </div>
                            <div className="col-md-4">

                                <div className="generic_content clearfix">

                                    <div className="generic_head_price clearfix">

                                        <div className="generic_head_content clearfix">

                                            <div className="head_bg"></div>
                                            <div className="head">
                                                <span> سه ماهه</span>
                                            </div>

                                        </div>
                                        <div className="generic_price_tag clearfix">
                                            <span className="price">
                                                <span className="currency">20,000,000</span>
                                                <span className="sign">ریال</span>
                                            </span>
                                        </div>

                                    </div>
                                    <div className="generic_feature_list">
                                        <ul>
                                            <li>بدون محدودیت درخواست</li>
                                        </ul>
                                    </div>

                                    <div className="generic_price_btn clearfix">
                                        <button type="button" onClick={(e) => rahpardaznet_payment('20000000', '0', '3')}>خرید اشتراک</button>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                    </>

                ) : null
            }


        </>
    )
}

export default Plans;